import { render, staticRenderFns } from "./Ovas.html?vue&type=template&id=2ff5bc5c&scoped=true&"
import script from "./Ovas.vue?vue&type=script&lang=js&"
export * from "./Ovas.vue?vue&type=script&lang=js&"
import style0 from "./Ovas.scss?vue&type=style&index=0&id=2ff5bc5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff5bc5c",
  null
  
)

export default component.exports